import { signOut } from 'firebase/auth';
import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Link } from 'react-router-dom';
import auth from '../../firebase.init';
import Loading from './Loading';

const Header = () => {
    const [user, loading] = useAuthState(auth);
    const logout = () => {
        signOut(auth);
        localStorage.removeItem('accessToken');
    }
    if (loading) {
        return <Loading />
    }

    const menuItems = <>

        <li> <Link to="/myportfolio">My Portfolio</Link></li>
        <li><Link to='/blog'>Blog</Link></li>
        <li>{user && <Link to='/dashboard'>DashBoard</Link>}</li>
        <li>{!user && <Link to='/signup'>Sign-Up</Link>}</li>
        <li>{!user && <Link to='/login'>Login</Link>}</li>


    </>
    return (
        <div className="navbar bg-base-100 bg-neutral text-neutral-content">
            <div className="navbar-start">
                <div className="dropdown">
                    <label tabIndex="0" className="btn btn-ghost lg:hidden">

                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabIndex="0" className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                        {menuItems}
                    </ul>
                </div>
                <a href="/#" className="btn btn-ghost normal-case text-xl">ToolsCollection</a>
            </div>
            <div className='navbar-end'>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal p-0 ">
                        {menuItems}
                    </ul>
                </div>
                <div className="mx-auto bg-neutral">
                    {user &&
                        <div className="dropdown dropdown-end ">
                            <label tabIndex="0" className="btn btn-ghost btn-circle avatar">
                                <div className="w-10 rounded-full">
                                    <img src="https://api.lorem.space/image/face?hash=33791" alt='profile-img' />
                                </div>
                            </label>

                            <ul tabIndex="0" className="bg-neutral menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">

                                <li>
                                    
                                {user?.displayName || user.name}


                                </li>
                                <li>Settings</li>
                                <li><button className="btn btn-primary" onClick={logout}>Logout</button></li>

                            </ul>

                        </div>
                    }
                </div>

            </div>
            <div className='navbar-end'>
                <label tabIndex="1" htmlFor="sidebar" className="btn btn-ghost lg:hidden">

                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                </label>
               
            </div>

        </div>
    )
};

export default Header;